<template>
  <article :class="['member-login']">

    <!-- <memberInfo-header
    :titleText='titleText'
    ></memberInfo-header> -->

    <section class="member-container">

      <div class="head-portrait">
        <img :src="headPortraitImg" alt="">
        <span>{{nickname}}</span>
      </div>

      <!-- <div class="member-info-wrap"> -->
      <inputinfo
      :inputItems='inputItems'
      :className='memberLogin'
      ></inputinfo>
      <!-- </div> -->

    </section>

    <memberInfo-footer
    :btnText="btnText"
    :save_info="save_info"
    >
    </memberInfo-footer>
  </article>
</template>

<script>

  import Footer from './child-components/Footer'
  import Header from './child-components/Header'
  import InputInfo from './child-components/InputInfo'

  export default {
    name:"member-login",
    data(){
      return {
        // header title,val:""
        titleText:"会员信息",

        nickname:"ONEPIECE",
        headPortraitImg:"https://hbimg.huabanimg.com/7b1eebb5528c59c044c479ea01b62b45f45cbdc259481-4SuG84_fw658",

        btnText:"保存信息",
        save_info:true,

        // input-item
        memberLogin:"member-info",
        checkBoxClassName:"testCB",
        inputItems:[
          {id:1,title:"会员姓名",type:"text",className:"memberName",disabled:false,placeholder:"请输入您的真实姓名"},
          {id:2,title:"证件号码",type:"text",className:"memberID",disabled:false,placeholder:"请输入您的证件号码"},
          {id:3,title:"联系电话",type:"number",className:"memberPhone",disabled:false,placeholder:"请输入您的联系电话"},
        ],
      }
    },
    components:{
      "memberInfo-footer":Footer,
      "memberInfo-header":Header,
      "inputinfo":InputInfo,
    },
    methods:{

    },

  }
</script>

<style scoped lang="less">

  @import '.././style/variable';

  .member-container{
    flex: 1;
    .overfA();
    padding: @headerPaddingLr;
    .head-portrait{
      .flex_wrap(center,center,nowrap,column);
      img{
        width: 2rem;
        height: 2rem;
        .radius(50%);
        margin-top: 10px;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, .8);
      }
      span{
        .marginTb();
        font-weight: 600;
        color: #666;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, .2);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/MemberInfoInput.vue